/**
 * FilterButtonGroup
 */
import React from 'react';
/** Main description for this component. */
var FilterButtonGroup = function (_a) {
    var children = _a.children;
    return (React.createElement("div", { role: "tablist", "aria-label": "tablist", className: "filter-button-group relative overflow-auto whitespace-no-wrap pt-1 pl-1" }, children));
};
export default FilterButtonGroup;
